import { type ChatFastAction } from "@do/shared-types";
import { type ChatContextType } from "../../../../providers/chat-provider";

type MessageButtonType = "store" | "url" | "tel" | "code" | "payload";

type MessageButtonClickHandlerOptions = {
  id: string;
  buttonType: MessageButtonType;
  isBackButton?: boolean;
};

export const buildFastActionFromButton = (
  button: ChatFastAction,
  {
    id,
    rewriteUrl,
  }: {
    id: string;
    rewriteUrl?: (url: string) => string;
  }
): ChatFastAction => ({
  id,
  code: button.code,
  cuid: button.cuid,
  fsmDef: button.fsmDef,
  metadata: button.metadata,
  payload: button.payload,
  tel: button.tel,
  title: button.title,
  url: button.url && rewriteUrl ? rewriteUrl(button.url) : button.url,
});

export const createMessageButtonClickHandler = (
  chat:
    | Pick<
        ChatContextType,
        | "handleBackToPreviousStep"
        | "onFastAction"
        | "rewriteUrl"
        | "setLastClickedButton"
        | "isMobile"
      >
    | null
    | undefined,
  button: ChatFastAction,
  { id, buttonType, isBackButton = false }: MessageButtonClickHandlerOptions
) => {
  return () => {
    if (!chat) return;

    if (isBackButton) {
      chat.handleBackToPreviousStep();
      return;
    }

    const requiresDesktopCallConfirmation = buttonType === "tel" && !chat.isMobile;
    if (!requiresDesktopCallConfirmation) {
      chat.setLastClickedButton?.({ cuid: button.cuid ?? null, type: buttonType });
    }
    chat.onFastAction(buildFastActionFromButton(button, { id, rewriteUrl: chat.rewriteUrl }));
  };
};
